<template>
    <v-list two-line subheader>
        <v-subheader >Lista de usuarios</v-subheader>
        <v-divider></v-divider>
        <v-flex xs12 pa-3 text-center>
            <h1 v-if="!items || items.length === 0" class="caption font-weight-light">No se han cargado usuarios.</h1>
        </v-flex>
        <v-list-item
                v-for="item in items"
                :key="item.email"
                @click="onClick(item, me(item.id))"
        >
            <v-list-item-avatar>
                <v-img v-if="item.avatar" :src="item.avatar"/>
                <v-icon
                        v-else
                >fas fa-user</v-icon>
            </v-list-item-avatar>


            <v-list-item-content class="text-left">
                <v-list-item-title v-text="item.first_name ? item.full_name + meText(item.id) : item.email + meText(item.id)"></v-list-item-title>
                <v-list-item-subtitle>
                    <v-icon v-if="item.role_id===3" class="mr-1" title="Especialista" size="19" color="secondary">fas fa-user-md</v-icon>
                    <v-icon v-if="item.role_id===2" class="mr-1" title="Administrativo" size="19" color="secondary">fas fa-user-tie</v-icon>
                    <v-icon v-if="item.role_id===1" class="mr-1" title="Gerente" size="19" color="secondary">fas fa-chart-line</v-icon>
                    <v-icon class="mr-1"  :title="item.confirmed ? 'Confirmado' : 'Sin confirmar'" size="19"  color="secondary"> {{item.confirmed ? 'far fa-check-circle' : 'far fa-clock'}}</v-icon>
                    <v-icon v-if="item.is_admin" class="mr-1" title="Administrador" size="19" color="accent">fas fa-tools</v-icon>
                    <v-chip v-if="!item.confirmed && !me(item.id)" small outlined color="black" @click.stop="onResend(item)">
                        <v-avatar>
                            <v-icon size="16">far fa-paper-plane</v-icon>
                        </v-avatar>
                        reenviar
                    </v-chip>
                </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
                <v-btn v-if="!me(item.id)" icon @click.stop="onDelete(item)" depressed>
                    <v-icon color="pink lighten-1" size="16">far fa-trash-alt</v-icon>
                </v-btn>
            </v-list-item-action>
        </v-list-item>

        <kimsa-confirm
                :close-on-confirm="false"
                :loading="loadingDelete"
                ref="deleteDialog"
                :title="confirmTitle"
                :content="confirmContent"
                v-on:confirm="onDeleteConfirm"/>

        <kimsa-confirm
                :close-on-confirm="false"
                :loading="loadingResend"
                ref="resendDialog"
                :title="confirmTitle"
                :content="confirmContent"
                v-on:confirm="onResendConfirm"/>
    </v-list>
</template>

<script>
    import KimsaConfirm from '@/components/common/KimsaConfirm'
    import {mapMutations, mapState} from 'vuex'

    import {ApiUtils} from '@/utils/ApiUtils'

    export default{
        components: { KimsaConfirm },
        props: ['items'],
        data(){
            return {
                loadingDelete: false,
                loadingResend: false,
                confirmTitle: '',
                confirmContent: '',
                selectedItem: null
            }
        },
        methods:{
            ...mapMutations(['showSnackBar']),
            me(userId){
                const vm = this
                return vm.currentUser && vm.currentUser.id === userId
            },
            meText(userId){
              const vm = this
              return vm.me(userId) ? ' (Yo)' : ''
            },
            onDelete(item){
                var vm = this
                vm.selectedItem = item
                vm.confirmTitle = `Desvincular a ${vm.selectedItem.first_name || 'Usuario'}`
                vm.confirmContent = 'Seguro(a) que deseas desvincular esta cuenta?'
                vm.$refs.deleteDialog.show()
            },
            onResend(item){
                var vm = this
                vm.selectedItem = item
                vm.confirmTitle = `Invitar a ${vm.selectedItem.first_name || 'Usuario'}`
                vm.confirmContent = 'Seguro(a) que deseas reenviar invitacion?'
                vm.$refs.resendDialog.show()
            },
            async onDeleteConfirm(){

                var vm = this
                if(vm.loadingDelete) return

                vm.loadingDelete = true
                const response = await ApiUtils.makeDelete(`provider/${vm.currentProvider.id}/members`, null, {
                    users: [vm.selectedItem.id]
                })
                vm.loadingDelete = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando desvincular la cuenta')
                    return
                }

                const json = await response.json()
                const detached = json.result.detached_users.length > 0 ?  json.result.detached_users[0] : null
                if(detached){
                    vm.$emit('detach', detached)
                }

                vm.$refs.deleteDialog.hide()

            },
            async onResendConfirm(){
                var vm = this
                if(vm.loadingResend) return

                vm.loadingResend = true
                const response = await ApiUtils.makePost(`provider/${vm.currentProvider.id}/invitation/resend`, {
                    emails: [vm.selectedItem.email]
                })
                vm.loadingResend = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando reenviar la invitacion')
                    return
                }

                vm.$emit('resend')
                vm.showSnackBar('Invitacion reenviada')
                vm.$refs.resendDialog.hide()

            },
            onClick(item, isMe){
                var vm = this
                vm.selectedItem = item
                vm.$emit('select', item, isMe)
            }
        },
        computed: {
                ...mapState(['currentUser', 'currentProvider'])
        },
        watch:{
            selectedItem(item){
                var vm = this
            }
        }
    }
</script>
